import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let heigthValue;
addEventListener('setVitalSignHeigthValue', (e) => {
    const ce = e;
    heigthValue = ce.detail.heigthValue;
});
export const VITAL_SIGN_HEIGHT_VALUE_VALIDATOR = 'vital-sign-height-value-validator';
async function vitalSignHeightValueValidator(value) {
    let valid = false;
    let message = '';
    if (heigthValue && heigthValue > 0) {
        valid = (value && value.cd) ? true : false;
    }
    else {
        valid = true;
    }
    if (!valid) {
        message = MessageService.translate('label.inform-the-unit-of-measurement');
    }
    heigthValue = undefined;
    return [{
            message: message,
            name: VITAL_SIGN_HEIGHT_VALUE_VALIDATOR,
            valid: valid
        }];
}
export default vitalSignHeightValueValidator;
//# sourceMappingURL=vital-sign-height-measure-unit-validator.js.map